export default __webpack_public_path__ + "static/media/LETO@FIFOU-3702.177306dd.jpg";